import { gql } from "generated-graphql";
import { TenantDefaultVerifiersQuery } from "generated-graphql/graphql";

export const TENANT_DEFAULT_VERIFIERS = gql(`
  query TenantDefaultVerifiers($tenantId: ID!) {
    tenantDefaultVerifiers(tenantId: $tenantId) {
      id
      tenantId
      state
      titleOverride
      person {
        ...PersonPicker
        ...PersonPickerDetails
      }
    }
  }
`);

export const DELETE_TENANT_DEFAULT_VERIFIER = gql(`
  mutation DeleteTenantDefaultVerifier($id: ID!) {
    deleteTenantDefaultVerifier(id: $id) {
      id
    }
  }
`);

export type DefaultVerifierRow = TenantDefaultVerifiersQuery["tenantDefaultVerifiers"][number];

export const UPSERT_TENANT_DEFAULT_VERIFIER = gql(`
  mutation UpsertTenantDefaultVerifier($input: UpsertTenantDefaultVerifierInput!) {
    upsertTenantDefaultVerifier(input: $input) {
      id
    }
  }
`);
